import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import routes from '../../features/routing/presentation/routes';
import RouteSuspenseFallback from '../../features/routing/presentation/components/RouteSuspenseFallback';
import RequireAuth from '../../features/auth/presentation/components/RequireAuth';
import { WorkspaceLayout } from '../../features/workspace/presentation/WorkspaceLayout';
import '../../components/App/App.css';

export default function App() {
  return (
    <Router>
      <Routes>
        {routes.map((route) => {
          // Every route element passes through WorkspaceLayout. For
          // workspace-scoped routes it forces unmount-on-switch via the
          // key={workspaceId} pattern and triggers me/summary refresh.
          // For non-workspace routes (auth, onboarding) it's a no-op
          // with a stable key.
          const RouteElement = route.element;
          const body = <RouteElement />;
          // One Suspense for the whole route table. Nearly every route is a
          // `lazyRoute`, so this is what renders while a page's chunk is on
          // the wire. It sits inside WorkspaceLayout so the workspace keying
          // and summary refresh still run while a page is arriving, and
          // above RequireAuth so an auth-gated page suspends the same way
          // as a public one.
          const wrapped = (
            <WorkspaceLayout>
              <Suspense fallback={<RouteSuspenseFallback />}>
                {route.requiresAuth ? <RequireAuth>{body}</RequireAuth> : body}
              </Suspense>
            </WorkspaceLayout>
          );
          return <Route key={route.path} path={route.path} element={wrapped} />;
        })}
      </Routes>
    </Router>
  );
}
